import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { take, tap } from 'rxjs/operators';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { RadioCardModel } from '../../../../core/models/radio-card.model';
import { DocumentsService } from '../../../../../app/core/providers/services/documents/documents.service';
import { CommonService } from '../../../../core/providers/forms/common.service';
import { GarantiasOpcionalesService } from '../../../../../app/core/providers/services/garantias-opcionales/garantias-opcionales.service';
import { GarantiasResModel } from '../../../../core/models/garantias.model';
import { UtilsService } from '../../../services/utils/utils.service';
import { Numbers } from 'src/app/utils/constants';
import { NavigationEnd, Router } from '@angular/router';
@Component({
  selector: 'app-calc-budget-step-two',
  templateUrl: './calc-budget-step-two.component.html',
  styleUrls: ['./calc-budget-step-two.component.scss']
})
export class CalcBudgetStepTwoComponent implements OnInit, AfterViewInit {

  /**
   * @description Es el formulario
   */
  @Input() FORM_DATA: FormGroup;

  /**
   * @description Es la configuracion del formulario
   */
  @Input() FORM_CONFIG: any;

  @Output() CLICK_BTN: EventEmitter<'back' | 'next'> = new EventEmitter();

  public showModal = false;
  public dataModal: RadioCardModel = null;
  public textPrice = 'form.price';
  public insuranceDuration = '';
  displayModal: boolean;
  insureSelected: string;
  idxDialog: number = Numbers.number0;
  currentStep: number = Numbers.number0;
  idProduct: number = Numbers.number0;
  documentsConst: any = {
    idProveedor: Numbers.number1,
    idPortal: Numbers.number1,
    productGeneral: Numbers.number1,
    productIPId: Numbers.number8,
    productNota: Numbers.number9,
    generalName: 'condicionado_general',
    ipidName: 'document_ipid',
    notaName: 'document_nota'
  };
  listGaranties: any[] = [];

  //#region Constructor
  /**
   * @ignore
   */
  constructor(
    private commons: CommonService,
    private document: DocumentsService,
    private utilsSrv: UtilsService,
    private gtmService: GoogleTagManagerService,
    private garanteeSrv: GarantiasOpcionalesService,
    private renderer: Renderer2
  ) {
    this.commons = commons;
    this.document = document;
    this.utilsSrv = utilsSrv;
    this.gtmService = gtmService;
    this.garanteeSrv = garanteeSrv;
    this.renderer = renderer;
  }
/**
 * @description Metodo de inicio
 */
  ngOnInit() {
    this.currentStep = this.FORM_CONFIG.currentStep.value;
    this.insureSelected = this.FORM_CONFIG.numberOfInsured.linkFormPath[0];
    const valueGuarantee: any = this.FORM_DATA.get([this.insureSelected, 'guaranteeLimitOfMedicalExpenses']).value;
    this.insuranceDuration = this.FORM_DATA.get([this.insureSelected, 'insuranceDuration']).value;
    this.idProduct = valueGuarantee.idProducto;
    this.getGarantees();
    window.scrollTo(0, 0);
  }
/**
 * @description Despues de cargar la vista
 */
  ngAfterViewInit(): void {
    const linkToggle: NodeListOf<Element> = document.querySelectorAll('.js-toggle');
    linkToggle.forEach(element => {
      element.addEventListener('click', function(event: Event): void {
        event.preventDefault();
        const container: HTMLElement = document.getElementById(this.dataset.container);
        if (container.classList.contains('active')) {
          container.classList.add('inactive');
          container.classList.remove('active');
        } else {
          container.classList.add('active');
          container.classList.remove('inactive');
        }
      });
    });
  }

  /**
   * @description botón siguiente o anterior
   */
  public clickButton(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.datalayer2();
    } else {
      // localStorage.removeItem('radio-card');
      sessionStorage.removeItem('radio-card');
      localStorage.setItem('prev-step1', 'true');
    }
    this.CLICK_BTN.emit(ev);
  }

  /**
   * @description Recupera la lista global de garantias del producto
   */
  getGarantees(): void {
    const listGaranties: any[] = this.FORM_DATA.get([this.insureSelected, 'guaranteeSelectionList']).value;
    this.garanteeSrv.getGaranteeOptional(this.idProduct)
      .pipe(
        take(1),
        tap((e: any) => {
          if (e !== null && e.length > 0) {
            const maped: any = e.map(el => new GarantiasResModel(el));
            let auxVal: any[];
            if (listGaranties.length > 0) {
              listGaranties.forEach(item => {
                auxVal = maped.filter(i => i.idGarantia === item.idGarantia);
                item.literal = auxVal[0].literal;
              });
              this.listGaranties = listGaranties;
            } else {
              this.listGaranties = [];
            }
          } else {
            this.listGaranties = [];
          }
        })
      ).subscribe();
  }
  /**
   * @description validación del evento para mostrar el modal de cobertura
   */
  public openCoverage(ev: { radio: RadioCardModel, idx?: number }): void {
    this.dataModal = ev.radio;
    this.showModal = true;
    this.idxDialog = ev.idx + 1;
    this.showModalDialog();
  }
  /**
   * @description validación del evento para ocultar el modal de cobertura
   */
  public closeCoverage(): void {
    this.dataModal = null;
    this.showModal = false;
    this.idxDialog = 0;
  }
  /**
   * @description retorna el valor para mostrar/ocultar el modal de cobertura
   */
  public getModalState(): boolean {
    return this.showModal;
  }

  /**
   * @description mostrar modal
   */
  showModalDialog(): void {
    this.displayModal = true;
  }

  /**
   * @description download ipid file service
   */
  downloadFileService(idNumber: number): void {
    const idDoc: number = idNumber;
    const idProveedor: number = this.documentsConst.idProveedor;
    const idPortal: number = this.documentsConst.idPortal;
    const idTipoDocumento: number = this.documentsConst.productIPId;

    this.document.getAditinalDocument(idDoc, idProveedor, idPortal, idTipoDocumento)
      .pipe(take(1))
      .subscribe((res) => {
        this.downloadFile(res, this.documentsConst.ipidName);
        // this.auditService(1);
      });
  }

  /**
   * @description download nota file service
   */
  downloadFileServiceN(idNumber: number): void {
    const idDoc: number = idNumber;
    const idProveedor: number = this.documentsConst.idProveedor;
    const idPortal: number = this.documentsConst.idPortal;
    const idTipoDocumento: number = this.documentsConst.productNota;

    this.document.getAditinalDocument(idDoc, idProveedor, idPortal, idTipoDocumento)
      .pipe(take(1))
      .subscribe((res) => {
        this.downloadFile(res, this.documentsConst.notaName);
        // this.auditService(2);
      });
  }

  /**
   * @description download file
   */
  downloadFile(item: ArrayBuffer, name?: string): void {
    const doc: ArrayBuffer = item;
    let filename: string;
    const file: Blob = this.commons.b64toBlob(doc, 'application/pdf');
    if (name !== '') {
      filename = name;
    } else {
      filename = 'document';
    }
    // Chrome
    const linkElement: HTMLElement = this.renderer.createElement('a');
    const url: string = window.URL.createObjectURL(file);

    this.renderer.setAttribute(linkElement, 'href', url);
    this.renderer.setAttribute(linkElement, 'download', filename);

    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    });
    linkElement.dispatchEvent(clickEvent);
    this.datalayer(filename);
  }

  /**
   * @description download ipid file service
   */
  auditService(type: any): void {
    let actionText = '';
    let mensajeText = '';
    switch (type) {
      case 1:
        actionText = this.utilsSrv.getTranslate('form3.actionTextCase1');
        mensajeText = this.utilsSrv.getTranslate('form3.mensajeTextCase1');
        break;
      case Numbers.number2:
        actionText = this.utilsSrv.getTranslate('form3.actionTextCase2');
        mensajeText = this.utilsSrv.getTranslate('form3.mensajeTextCase2');
        break;
      default:
        actionText = this.utilsSrv.getTranslate('form3.actionTextCaseD');
        mensajeText = this.utilsSrv.getTranslate('form3.mensajeTextCaseD');
        break;
    }
  }

  /**
   * @description asignar evento analítica
   */
  datalayer(nameDoc: string): void {
    const nameDoc2: string = nameDoc.split(' ').join('_');
    const datalayerD: {
      event: string;
      event_category: string;
      event_action: string;
      event_label: string;
  } = {
      event: 'ev_descarga',
      event_category: 'descarga',
      event_action: nameDoc2,
      event_label: '-'
    };
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * @description asignar evento analítica
   */
  datalayer2(): void {
    const formName: any = this.FORM_DATA.get('insureSelected').value;
    const datalayerD: {
      event: string;
      event_category: string;
      event_action: any;
      event_label: string;
      categoria_seguro: string;
      paso: string;
  } = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'viajes',
      paso: 't2'
    };
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * @description comprueba que se trata de un seguro de particulares y temporal
   * @returns confirmacion si es de particulares y temporal
   */
  isPartAndTemp(): boolean {
    if (this.insureSelected === 'particularTravelAsistance' && this.insuranceDuration === 'Temporal'
        && this.FORM_CONFIG.insuranceType.radioCardList[0].title !== 'Precio') {
      this.FORM_CONFIG.insuranceType.radioCardList[0].title = 'Precio';
      this.FORM_CONFIG.insuranceType.radioCardList[0].subTitle = '';
      this.FORM_CONFIG.insuranceType.radioCardList[0].desc1 = 'Aseguradora líder en asistencia en viaje';
      this.FORM_CONFIG.insuranceType.radioCardList[0].desc2 = 'Expertos en asistencia médica';
      this.FORM_CONFIG.insuranceType.radioCardList[0].desc3 = 'Contact Center propio';
    }
    return (this.insureSelected === 'particularTravelAsistance' && this.insuranceDuration === 'Temporal');

  }
}
